import { createSlice } from '@reduxjs/toolkit';

export const homePageTwo = createSlice({
  name: 'homePageTwo',
  initialState: {
    data: {},
  },

  reducers: {
    setHomePageTwo: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setHomePageTwo } = homePageTwo.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getHomePageTwo = (state) => {
  return state.homePageTwo.data;
};

export default homePageTwo.reducer;
